module.exports = __webpack_public_path__ + "static/media/9DESA3.c5a5ed54.jpg";